import {Component, Input, OnInit} from '@angular/core';
import {ShipmentService} from "../../../../../../open-api-generated/services/shipment.service";
import {ShipmentInvoice} from "../../../../../../open-api-generated/models/shipment-invoice";
import {Amount} from "../../../../../../open-api-generated/models/amount";

@Component({
  selector: 'app-shipment-finance-card',
  templateUrl: './shipment-finance-card.component.html',
  styleUrls: ['./shipment-finance-card.component.scss']
})
export class ShipmentFinanceCardComponent implements OnInit {
  @Input('internalNumber') public internalNumber: string = null;
  @Input('shipmentCurrency') shipmentCurrency: string = null;

  invoices: ShipmentInvoice[] = null;

  mainIncomeAmount: Amount = null;

  afterServiceIncomeAmount: Amount = null;

  constructor(
    private shipmentService: ShipmentService,
  ) {

  }

  ngOnInit() {
    this.shipmentService.appV2ShipmentInvoices(
      {
        internalNumber: this.internalNumber
      }
    ).subscribe(
      (invoices: any) => {
       this.invoices = invoices;
      }
    );

    this.shipmentService.appV2ShipmentAccountedAmounts({
      internalNumber: this.internalNumber
    }).subscribe(
      (accountedAmounts: any) => {
        this.mainIncomeAmount = accountedAmounts.accounted_amounts.main;
        this.afterServiceIncomeAmount = accountedAmounts.accounted_amounts.after_service;
      }
    );
  }

  openInvoice(id: number) {
    window.open(
      '/invoices/'+id,
      '_blank'
    );
  }
}
